import axios, { AxiosInstance, InternalAxiosRequestConfig } from 'axios';
import CookieFunction from '@/functions/cookieFunction';
import ToolbarIcons from '@/icons/toolbar';
import { getLocale } from '@/functions/getLocale';
import React from 'react';

// const subCategoryTypeApi2 = {
//   vehicle_fines: '3',
//   driving_license_status: '9',
//   negative_points: '7',
//   vehicle_violations_summary: '2',
//   license_plate_history: '4',
//   user_active_license_plates: '6',
//   travel_ban_status: '10',
//   passport_status: '8',
//   fines_without_identity_verification: '1',
//   vehicle_card_and_document_status: '5',
//   vehicle_fines_image: '11',
// };
const subCategoryTypeApi = {
  vehicle_fines: 'Violation_Report',
  driving_license_status: 'Driving_Licenses',
  negative_points: 'Driving_License_Negtv_Point',
  vehicle_violations_summary: 'Aggregate_Violation',
  license_plate_history: 'Plates_History',
  user_active_license_plates: 'License_Plates',
  travel_ban_status: '9',
  passport_status: 'Passport_Report',
  fines_without_identity_verification: 'Aggregate_Violation_Noauth',
  vehicle_card_and_document_status: 'Plate_Documents_Status',
  vehicle_fines_image: 'Violations_Image',
};
export const vehicle_fine_path = '/service/خلافی-خودرو';
export const subCategoryIdList = subCategoryTypeApi;

export const transactionTypes = {
  TransactionSubTypeChargeWallet: 1,
  TransactionSubTypeNajiCall: 2,
  TransactionSubTypeDept: 3,
  TransactionSubTypeAdminAction: 4,
  TransactionSubTypeAllViolation: 5,
  TransactionSubTypeDeptall: 6,
  TransactionSubTypeShopping: 7,
  TransactionSubTypeRefund: 8,
};
// var transactionSubTypeTitles = map[int]string{
// 	TransactionSubTypeChargeWallet: "شارژ کیف پول", //1
// 	TransactionSubTypeNajiCall:     "استعلام",      //2
// 	TransactionSubTypeDept:         "بدهی",         //3
// 	TransactionSubTypeAdminAction:  "عملیات ادمین", //4
// 	TransactionSubTypeAllViolation: "همه تخلفات",   //5
// 	TransactionSubTypeDeptall:      "تجمیع بدهی",   //6
// 	TransactionSubTypeShopping:     "خرید",         //7
// 	TransactionSubTypeRefund:       "بازگشت وجه",   //8
// }
export const bankTransactionType = {
  deposit: 1,
  withdraw: 2,
};
export const paymentMethodsList = {
  wallet: 1,
  bank: 2,
};
export const transactionStatusTitles = {
  TransactionStatusFailed: 0, //   "خطا/لغو شده", //0
  TransactionStatusSuccess: 1, // "موفق", //1
  TransactionStatusPending: 2, //"در حال انجام", //2
  TransactionStatusVerified: 3, // "تایید شده", //3
};
export const InqStatusTitles = {
  TransactionStatusFailed: 0, //   "خطا/لغو شده", //0
  TransactionStatusSuccess: 1, // "موفق", //1
  TransactionStatusPending: 2, //"در حال ", // پردازش
};
//  process.env.url?.includes('api2')
//   ? subCategoryTypeApi2
//   : subCategoryTypeApi;
interface LanguageItem {
  id: string;
  title: string;
}

interface ModeItem {
  id: string;
  title: string;
  icon: React.ReactElement;
}

// interface ConfigHeaders {
//   Authorization?: string;
//   'Channel-Id'?: number | string;
//   language?: string;
//   Accept?: string;
//   [key: string]: any;
// }
interface ConfigHeaders {
  Authorization?: string;
  'Channel-Id'?: string;
  lang?: string;
  userId?: string;
  carId?: string;
  Accept?: string;
  [key: string]: string | undefined;
}

interface AppConfig {
  Langs: LanguageItem[];
  menu: Record<string, number>;
  defaultLocale: string;
  RTL_LANGUAGES: string[];
  baseURL: string | undefined;
  tokenName: string;
  modeName: string;
  themeName: string;
  userIdCara: string;
  carIdCara: string;
  caraCart?: string;
  superUserIdCara?: string;
  levelManageName: string;
  // userAuthAixi: string;
  // afterSignupAixi: string;
  isRTL: (lang: string) => boolean;
  modes: ModeItem[];
  udata: string | boolean | undefined;
  user_Id: string | boolean | undefined;
  car_Id: string | boolean | undefined;
  axiosHandle: (headers?: ConfigHeaders | null) => AxiosInstance;
  axiosHandleShop: (headers?: ConfigHeaders | null) => AxiosInstance;
  apiFolder?: string;
}

const tokenName = 'caraToken';
const modeName = 'aixiMode';
const themeName = 'aixiTheme';
const levelManageName = 'aixiLevelManage';
const userAuthCara = 'userAuthCara';
const userIdCara = 'userIdCara';
const carIdCara = 'carIdCara';
const caraCart = 'caraCart';
const superUserIdCara = 'superUserIdCara';

const MENU_IDS = {
  DASHBOARD: 11,
  PERSONAL_INFORMATION: 1,
  MY_SERVICE: 2,
  BOOKED_HISTIRY: 3,
  PAYMENT: 4,
  MARKED_SERVICES: 5,
  SETTING: 6,
  LOGOUT: 7,
};

export const TRIGGERS = {
  BASKETMODAL: 'basket_modal',
  RERENDER_BASKETMODAL: 'rerender_basket_modal',
  COMPARE_MODAL: 'compare_modal',
  MOBILEMENU: 'mobile_menu',
  ADDRESS_MODAL: 'address_modal',
  FORM_MODAL: 'form_modal',
  RERENDER: 'rerender',
  PRODUCT_FILTERS: 'product_filters',
  ORDER_DETAILS: 'order_details',
  OPEN_MODAL: 'open_modal',

  LOGIN_MODAL: 'login_modal',
  PAYMENT_MODAL: 'payment_modal',
  SUBUSER_MODAL: 'subUser_modal',
  ADD_SUBUSER: 'add_subUser',
  EDIT_PLATE_MODAL: 'edit_plate_modal',
  RESERVE_SERVICE: 'reserve_service',
  EMPTY: null,
};

export const apiFolder = 'v0';

export const getHeaders = ({
  locale,
  token,
  userId,
  carId,
  extraHeaders = {},
}: {
  locale: string;
  token?: string;
  userId?: string;
  carId?: string;
  extraHeaders?: ConfigHeaders;
}) => ({
  Authorization: token ? `Bearer ${token}` : '',
  language: locale,
  sub_user_id: userId,
  car_id: carId,
  Accept: 'application/json',
  ...extraHeaders,
});
const config: AppConfig = {
  Langs: [
    { id: 'en', title: 'english' },
    { id: 'fa', title: 'farsi' },
  ],
  menu: MENU_IDS,
  defaultLocale: 'fa',
  RTL_LANGUAGES: ['ar', 'fa'],
  // baseURL: process.env.url,
  baseURL: '',
  tokenName: tokenName,
  modeName: modeName,
  themeName: themeName,
  levelManageName: levelManageName,
  userIdCara: userIdCara,
  superUserIdCara: superUserIdCara,
  carIdCara: carIdCara,
  caraCart: caraCart,
  apiFolder: apiFolder,

  // تابع isRTL
  isRTL: (x: string) => config.RTL_LANGUAGES.includes(x),

  modes: [
    { id: 'light', title: 'light', icon: <ToolbarIcons.ChangeModeIcon /> },
    { id: 'dark', title: 'dark', icon: <ToolbarIcons.ChangeModeIconNight /> },
  ],

  // مقداردهی شرطی برای udata و channel_id
  udata:
    typeof window !== 'undefined' &&
    typeof document !== 'undefined' &&
    CookieFunction('get', tokenName),

  user_Id:
    typeof window !== 'undefined' &&
    typeof document !== 'undefined' &&
    CookieFunction('get', userIdCara),
  car_Id:
    typeof window !== 'undefined' &&
    typeof document !== 'undefined' &&
    CookieFunction('get', carIdCara),

  // تابع ساخت axios
  axiosHandle: (headers: ConfigHeaders | null = null) => {
    return axios.create({
      baseURL: `${config.baseURL}/api/`,
      headers: {
        Authorization: config?.udata ? `Bearer ${config?.udata}` : '',
        // 'Channel-Id': config.channel_id ? Number(config.channel_id) : '',
        language: getLocale(
          config.defaultLocale,
          config.Langs.map((d) => d.id),
        ),
        sub_user_id: config?.user_Id,
        car_id: config?.car_Id,
        Accept: 'application/json',
        ...headers,
      },
    });
  },
  axiosHandleShop: (headers: ConfigHeaders | null = null) => {
    return axios.create({
      baseURL: `${config.baseURL}/api/shop/`,
      headers: {
        Authorization: config?.udata ? `Bearer ${config?.udata}` : '',
        language: getLocale(
          config.defaultLocale,
          config.Langs.map((d) => d.id),
        ),
        Accept: 'application/json',
        ...headers,
      },
    });
  },
  // axiosHandle: (headers: ConfigHeaders | null = null) => {
  //   return axios.create({
  //     baseURL: `${config.baseURL}/api/`,
  //     headers: getHeaders(headers ?? {}),
  //   });
  // },
};

export default config;

// import axios from 'axios';
// import CookieFunction from '@/functions/cookieFunction';
// import ToolbarIcons from '@/icons/toolbar';
// import { getLocale } from '@/functions/getLocale';

// const tokenName = 'aixiToken';
// const modeName = 'aixiMode';
// const themeName = 'aixiTheme';
// const levelManageName = 'aixiLevelManage';
// const userAuthAixi = 'userAuthaixi';
// const afterSignupAixi = 'afterSignupaixi';

// const MENU_IDS = {
//   DASHBOARD: 11,
//   PERSONAL_INFORMATION: 1,
//   MY_SERVICE: 2,
//   BOOKED_HISTIRY: 3,
//   PAYMENT: 4,
//   MARKED_SERVICES: 5,
//   SETTING: 6,
//   LOGOUT: 7,
// };

// // const t = useTranslations('common');
// const config = {
//   // t: useTranslations('common'),
//   Langs: [
//     { id: 'en', title: 'english' },
//     { id: 'fa', title: 'farsi' },
//   ],
//   menu: MENU_IDS,
//   defaultLocale: 'en',
//   RTL_LANGUAGES: ['ar', 'fa'],
//   baseURL: process.env.url,
//   // baseURL: '',
//   tokenName: tokenName,
//   modeName: modeName,
//   themeName: themeName,
//   levelManageName: levelManageName,
//   userAuthAixi: userAuthAixi,
//   afterSignupAixi: afterSignupAixi,
//   isRTL: (x) => config.RTL_LANGUAGES.includes(x),
//   modes: [
//     { id: 'light', title: 'light', icon: <ToolbarIcons.ChangeModeIcon /> },
//     { id: 'dark', title: 'dark', icon: <ToolbarIcons.ChangeModeIconNight /> },
//   ],

//   udata:
//     typeof window !== 'undefined' &&
//     typeof document !== 'undefined' &&
//     CookieFunction('get', tokenName),
//   channel_id:
//     typeof window !== 'undefined' &&
//     typeof document !== 'undefined' &&
//     CookieFunction('get', userAuthAixi),

//   // udata:
//   //   'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE3NjMzNTc5MDgsInVzZXJfaWQiOjQsInVzZXJfbmFtZSI6ImM5OGZlMzIwLWU1NDgtNDI0Zi04ZmJjLWZmM2JkMjZhY2FhMCJ9.CCWe5VnF3ug00RMiZ4f6M2TFeOaLmP3AJh9IMLMxqoc',

//   axiosHandle: (headers = null) => {
//     return axios.create({
//       baseURL: `${config.baseURL}/api/`,
//       headers: {
//         Authorization: config?.udata ? `Bearer ${config?.udata}` : '',
//         // 'clipsho-theme': `black`,
//         // 'user-authorization': `12165`,
//         // 'GATEWAY-ID': '30',
//         'Channel-Id': config.channel_id ? Number(config.channel_id) : '',
//         language: getLocale(
//           config.defaultLocale,
//           config.Langs.map((d) => d.id),
//         ),
//         // channel_id: 3,
//         Accept: 'application/json',
//         // mode: 'no-cors',
//         // 'Access-Control-Allow-Origin': '*',
//         // withCredentials: false,
//         // cache: 'default',
//         ...headers,
//       },
//     });
//   },
// };
// export default config;
